import { render, staticRenderFns } from "./VerifyCaptcha.vue?vue&type=template&id=20cde927&scoped=true&"
import script from "./VerifyCaptcha.vue?vue&type=script&lang=js&"
export * from "./VerifyCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCaptcha.vue?vue&type=style&index=0&id=20cde927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cde927",
  null
  
)

export default component.exports